import { OrderStatus } from '@steelbuy/ts-shared';
import { BadgeVariant } from '@steelbuy/ui-primitive';

export function getBadgeVariant(status: OrderStatus) {
    if (status === OrderStatus.DELIVERED) {
        return BadgeVariant.POSITIVE;
    }
    return BadgeVariant.NEUTRAL;
}
